import React from "react";
import formatDate from "../../../utils/formatDate";

const AllNoticesTable = ({
  notices,
  activePage,
  pageSize,
  handleNoticeChange,
  hanldePdfFileUpload,
  handleUpdate,
  handleDelete,
  noticeTxtMaxLength,
}) => {
  return (
    <>
      <div className="table-responsive">
        <table className="table table-bordered notice-table text-nowrap">
          <thead className="text-nowrap">
            <tr>
              <th className="text-center">S.N.</th>
              <th className="w-100">Description</th>
              <th className="text-center">Release date</th>
              <th className="text-center">File</th>
              <th className="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            {notices &&
              notices.map((notice, index) => (
                <tr key={notice.id}>
                  <td>{(activePage - 1) * pageSize + index + 1}</td>
                  <td>
                    <div
                      className="form__div-container"
                      style={{ minWidth: "350px" }}
                    >
                      <div className="form__div">
                        <input
                          required
                          type="text"
                          name="notice"
                          className="form__input"
                          placeholder=" "
                          onChange={(e) => handleNoticeChange(e, notice.id)}
                          value={notice.titleEn}
                          maxLength={noticeTxtMaxLength}
                        />
                        <label className="form__label">
                          Notice Description
                        </label>
                      </div>
                    </div>
                  </td>
                  <td>{formatDate(notice.updateTime)}</td>
                  <td className="text-left">
                    <input
                      onChange={(e) => hanldePdfFileUpload(e, notice.id)}
                      className="d-none"
                      id={`pdfUploader${notice.id}`}
                      type="file"
                      accept="application/pdf"
                    />
                    <label htmlFor={`pdfUploader${notice.id}`}>
                      <i
                        className="fa fa-cloud-upload fa-2x clickable"
                        style={{ color: "rgba(53, 78, 128, 0.9)" }}
                      ></i>
                    </label>
                    <p
                      className="mb-0 text-ellipsis-100px"
                      title={notice.fileTag}
                    >
                      {notice.fileTag}
                    </p>
                  </td>
                  <td>
                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(notice.id)}
                    >
                      Delete
                    </button>
                    <button
                      className="save-btn ml-2"
                      onClick={() => handleUpdate(notice.id)}
                    >
                      save
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default AllNoticesTable;
